import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../messages';
import Global from '../../../../store/global-selectors';
import { Multiple } from '../../../../components/multiple-text-blurb-for-grid';
import { locationNameFromParts } from '../../../../products/product-details/display-helpers';

const name = <FormattedMessage {...messages.warehouseLocationColumnHeader} />;

const WarehouseLocation = ({ inventoryWarehouseLocationId }) => {
  const inventoryLocation = useSelector((state) =>
    Global.selectSellerInventoryWarehouseLocationsById(state, {
      inventoryWarehouseLocationId,
    }),
  );

  if (!inventoryLocation) {
    return '';
  }
  return locationNameFromParts(inventoryLocation || {});
};

export default {
  getMessageDescriptor: () => messages.warehouseLocationColumnHeader,
  name,
  render: (data, { isExpanded = false, isFirstRow = true, allData = [] }) => {
    if (!isExpanded && isFirstRow && Array.isArray(allData) && allData.length > 1) {
      return <Multiple />;
    }
    return <WarehouseLocation inventoryWarehouseLocationId={data.inventoryLocationId} />;
  },
};
